import * as fromActions from './types'
import * as R from 'ramda'

const initialState = {
  data: {},
  selected: [],
  flags: {
    fetch: 'none',
    acknowledge: 'none',
    issue: 'none',
  },
  updatedExceptionKeys: [],
  updatedExceptionStatus: null,
  apiResponse: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case fromActions.RESET:
      return resetFlags(state)

    case fromActions.FETCH:
      return updateFlags(state, { fetch: 'processing' })

    case fromActions.FETCH_ERROR:
      return updateFlags(state, { fetch: 'error' })

    case fromActions.FETCH_FULFILLED:
      return fetchFulfilled(state, action)

    case fromActions.ACKNOWLEDGE_EXCEPTIONS:
      return updateFlags(state, { acknowledge: 'processing' })

    case fromActions.ACKNOWLEDGE_EXCEPTIONS_ERROR:
      return acknowledgeError(state, action)

    case fromActions.ACKNOWLEDGE_EXCEPTIONS_FULFILLED:
      return acknowledgeFulfilled(state, action)

    case fromActions.SELECT_ROW:
      return onSelectRow(state, action)

    case fromActions.SAVE_EXCEPTION_NOTE:
    case fromActions.SAVE_EXCEPTION_NOTE_REQUEST:
      return {
        ...state,
        flags: { ...state.flags, saveNote: 'processing' },
        apiResponse: null,
      }
    case fromActions.SAVE_EXCEPTION_NOTE_SUCCESS:
      return {
        ...state,
        flags: { ...state.flags, saveNote: 'processed' },
        apiResponse: 'Note saved successfully.',
      }
    case fromActions.SAVE_EXCEPTION_NOTE_ERROR:
      return {
        ...state,
        flags: { ...state.flags, saveNote: 'error' },
        apiResponse: action.error || 'Failed to save note.',
      }
    case fromActions.GET_EXCEPTION_NOTES_REQUEST:
      return {
        ...state,
        flags: { ...state.flags, getNotes: 'processing' },
        apiResponse: null,
      }
    case fromActions.GET_EXCEPTION_NOTES_SUCCESS: {
      // No longer store notes in reportExceptions reducer
      return {
        ...state,
        flags: { ...state.flags, getNotes: 'processed' },
        apiResponse: null,
      }
    }
    case fromActions.GET_EXCEPTION_NOTES_ERROR:
      return {
        ...state,
        flags: { ...state.flags, getNotes: 'error' },
        apiResponse: action.error || 'Failed to fetch notes.',
      }

    case fromActions.GET_EXCEPTION_ISSUE_REQUEST:
      return {
        ...state,
        flags: { ...state.flags, issue: 'processing' },
      }
    case fromActions.GET_EXCEPTION_ISSUE_SUCCESS:
      return {
        ...state,
        flags: { ...state.flags, issue: 'processed' },
      }
    case fromActions.GET_EXCEPTION_ISSUE_ERROR:
      return {
        ...state,
        flags: { ...state.flags, issue: 'error' },
        apiResponse: action.error || 'Failed to fetch exception issue details.',
      }

    case fromActions.UPDATE_EXCEPTION_NOTE:
    case fromActions.UPDATE_EXCEPTION_NOTE_REQUEST:
      return {
        ...state,
        flags: { ...state.flags, updateNote: 'processing' },
        apiResponse: null,
      }
    case fromActions.UPDATE_EXCEPTION_NOTE_SUCCESS:
      return {
        ...state,
        flags: { ...state.flags, updateNote: 'processed' },
        apiResponse: 'Note updated successfully.',
      }
    case fromActions.UPDATE_EXCEPTION_NOTE_ERROR:
      return {
        ...state,
        flags: { ...state.flags, updateNote: 'error' },
        apiResponse: action.error || 'Failed to update note.',
      }

    case fromActions.DELETE_EXCEPTION_NOTE_REQUEST:
      return {
        ...state,
        flags: { ...state.flags, deleteNote: 'processing' },
        apiResponse: null,
      }
    case fromActions.DELETE_EXCEPTION_NOTE_SUCCESS:
      return {
        ...state,
        flags: { ...state.flags, deleteNote: 'processed' },
        apiResponse: 'Note deleted successfully.',
      }
    case fromActions.DELETE_EXCEPTION_NOTE_ERROR:
      return {
        ...state,
        flags: { ...state.flags, deleteNote: 'error' },
        apiResponse: action.error || 'Failed to delete note.',
      }

    default:
      return state
  }
}

export default reducer

const resetFlags = (state) => ({
  ...state,
  selected: [],
  apiResponse: null,
  flags: {
    fetch: 'none',
    acknowledge: 'none',
    issue: 'none',
  },
})
const updateFlags = (state, flags) => {
  return {
    ...state,
    flags: {
      ...state.flags,
      ...flags,
    },
  }
}

/* ---------- FETCH ---------- */

const fetchFulfilled = (state, { payload }) => {
  const apiResponse =
    payload?.apiResponse?.success === false
      ? payload.apiResponse.message
      : null

  return {
    ...state,
    data: payload?.data || {},
    apiResponse,
    flags: {
      ...state.flags,
      fetch: 'processed',
    },
  }
}

/* ---------- ACKNOWLEDGE ---------- */

const acknowledgeError = (state, { payload }) => {
  return {
    ...state,
    apiResponse: payload || 'Error occurred while acknowledging exceptions.',
    flags: {
      ...state.flags,
      acknowledge: 'error',
    },
  }
}

const acknowledgeFulfilled = (state, { payload, options }) => {
  const success = payload?.apiResponse?.success !== false

  return {
    ...state,
    apiResponse: success
      ? 'Exceptions acknowledged successfully.'
      : payload?.apiResponse?.message || 'Failed to acknowledge exceptions.',
    selected: [],
    updatedExceptionKeys: success ? options?.updatedExceptionKeys || [] : [],
    updatedExceptionStatus: success ? options?.updatedExceptionStatus || null : null,
    flags: {
      ...state.flags,
      acknowledge: success ? 'processed' : 'error',
    },
  }
}

const onSelectRow = (state, { payload }) => {
  const selected = R.clone(payload)
  return {
    ...state,
    selected,
  }
}
